import React from 'react';
import { AdmissionSectionList } from './components';
import { AdmissionBreadcrumbs } from 'src/components/breadcrumbs';
import styles from './admission.module.scss';
import { ScreenTitle } from 'src/components/design-system';
import { ViewSelector } from 'src/components/common/view-selector';
import classnames from 'classnames';
import { usePageTitle } from 'src/components/app/use-page-title';

const AdmissionPageComponent = React.memo(function AdmissionPageComponent({
  id,
  category = {},
  children = null,
  isReady = false,
  showBreadcrumbs = false,
}) {
  const { title, pathParts = [], fullPath, ownerIds, tags, workspaceId } = category;

  const { updateSubtitle } = usePageTitle();

  React.useEffect(() => {
    updateSubtitle(title);
  }, [title, updateSubtitle]);

  return (
    <div className={classnames([styles.root, 'new-design-system'])}>
      <div className={styles.header}>
        <div className={styles.headerTitle}>
          {showBreadcrumbs && (
            <AdmissionBreadcrumbs
              title={title}
              pathParts={pathParts}
              initialWorkspaceId={workspaceId}
            />
          )}

          <ScreenTitle title={title} />
        </div>
        <ViewSelector />
      </div>
      <AdmissionSectionList
        list={children}
        fullPath={fullPath}
        isReady={isReady}
        ownerIds={ownerIds}
        id={id}
        tags={tags}
      />
    </div>
  );
});

export { AdmissionPageComponent };
